import { Route } from '@angular/router';
import { TenderContractDashboardIndexAnalysisComponent } from '../../../../../../../pages';
import { SealedTenderGuard } from '../../../../../../guards/sealed-tender.guard';
import { graphRoute } from './children/graph';
import { listRoute } from './children/list';
import { yearOnYearRoute } from './children/year-on-year';

export const indexAnalysisRoute: Route = {
    path: 'index-analysis/round/:rid',
    component: TenderContractDashboardIndexAnalysisComponent,
    // Its siblings carry this guard and it did not; the nav link was hidden by *ngIf only, so
    // a bookmark reached the page. Index Analytics is one of the three screens locked for a
    // sealed tender while a round is open.
    canActivate: [SealedTenderGuard],
    children: [
        {
            path: '',
            redirectTo: 'graph',
            pathMatch: 'prefix'
        },
        graphRoute,
        yearOnYearRoute,
        listRoute
    ]
};
